import { CircularProgress, Icon, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import Http from '../../Http';
import './Dashboard.css';
import DashboardList from './DashboardList';

const DB_ITEM_TIPO = {
  LISTA: 1,
}

const getDashboard = async () => {
  let data = await Http.get(`usuario/dashboard`);
  if (data.error) return [];
  return data.data;
}

export default function Dashboard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    updateDashboard();
  }, []);

  const updateDashboard = async () => {
    setLoading(true);
    const data = await getDashboard();
    setItems(data);
    setLoading(false);
  }

  return (
    <div className='dash-container'>
      {loading && <div className='dash-overlay'><CircularProgress size={60} /></div>}
      <div className='dash-actions'>
        <Tooltip
          title={'Recargar'}
          placement="bottom"
        >
          <Icon
            color="primary"
            onClick={() => updateDashboard()}
          >
            refresh
          </Icon>
        </Tooltip>
      </div>
      {
        items.map((item) => {
          if (item.tipo === DB_ITEM_TIPO.LISTA) return <DashboardItem key={item.titulo} {...item} />
          return null;
        })
      }
    </div>
  )
}

const DashboardItem = ({ titulo, data, tipo, ...props }) => {
  console.log(data)
  return (
    <div className='dash-box'>
      <h1>{titulo}</h1>
      {
        tipo === DB_ITEM_TIPO.LISTA && <DashboardList listItems={data} />
      }
    </div>
  )
}